import { ResultsCard } from 'libs/searchspring/components/ResultCard'

export const ResultItem = ({ item, className, dataIndex, eager = false, imageSizes, imageWidths }) => {
  if ('value' in item) {
    return <div className="result-card" dangerouslySetInnerHTML={{ __html: item.value }} />
  }
  return (
    <ResultsCard
      result={item}
      className={className}
      dataIndex={dataIndex}
      eager={eager}
      imageSizes={imageSizes}
      imageWidths={imageWidths}
    />
  )
}
